import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconFileEmptyFilled } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import messages from './DefaultView.messages';
import styles from './DefaultView.module.css';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

const DefaultView = () => {
    return (
        <MainSectionWrapper className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <IconFileEmptyFilled className={styles.titleIcon} />
                </div>

                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>

                <div className={styles.bodyText}>
                    <FormattedMessage
                        data-test-id="declined-body-text"
                        {...messages.description}
                        values={{
                            phoneNumber: (
                                <a
                                    href={
                                        getCountry() === 'DE'
                                            ? 'tel:069 9432 3020 '
                                            : 'tel:020 3778 0274'
                                    }
                                    className={styles.phoneNumber}
                                >
                                    <FormattedMessage
                                        tagName="strong"
                                        {...messages.phoneNumber}
                                    />
                                </a>
                            )
                        }}
                    />
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default DefaultView;
